export default {
  choose: {
    title: '{{name}} come titolare: rimuovi',
    title_no_owner: 'Scegli un titolare per {{restaurant}}',
    description: 'Scegli chi subentra a {{name}}, oppure lascia {{restaurant}} per ora senza titolare.',
    description_no_owner: '{{restaurant}} non ha un titolare. Scegli qualcuno del team o una persona nuova.',
    new_owner: 'Nuovo titolare',
    previous_owner: '{{name}} dopo la modifica',
  },
  options: {
    team: {
      title: 'Qualcuno del team',
      loading: 'Caricamento del team…',
      description_one: 'Qualsiasi Operatore o Dipendente, {{count}} persona.',
      description_other: 'Qualsiasi Operatore o Dipendente, {{count}} persone.',
      empty: 'Non c’è ancora nessun altro nel team.',
      search: 'Cerca nel team per nome o email',
      no_match: 'Nessuno nel team corrisponde a “{{query}}”.',
    },
    new: {
      title: 'Una persona nuova',
      description: 'Diventa subito titolare e riceve le credenziali di accesso via email.',
    },
    none: {
      title: 'Nessun titolare per ora',
      description: 'Scegli un titolare più tardi. Fino ad allora {{restaurant}} resta senza titolare.',
    },
    keep: {
      title: 'Resta nel team come Operatore',
      description: 'Mantiene l’accesso ai ristoranti che gestisce oggi.',
    },
    remove: {
      title: 'Rimosso dal team',
      description: 'Perde subito l’accesso alla dashboard.',
    },
  },
  roles: {
    operator: 'Operatore',
    employee: 'Dipendente',
  },
  fields: {
    first_name: 'Nome',
    last_name: 'Cognome',
    email: 'Email',
  },
  email_errors: {
    invalid_email: 'Inserisci un’email valida, ad esempio nome@esempio.it.',
    email_is_owner: '{{name}} è già il titolare.',
    email_is_manager: '{{name}} fa già parte del team.',
    email_taken: 'Una persona esterna a questo team accede già con questa email. Usa un’altra email.',
  },
  confirm: {
    title: 'Rimuovere {{name}} come titolare?',
    title_no_owner: 'Nominare {{name}} titolare?',
    description_both: 'Le due modifiche avvengono insieme. Se una non riesce, non cambia nulla.',
    description: 'Controlla la modifica prima di confermare.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> resta senza titolare finché non ne scegli uno. Tutto ciò che richiede il titolare resta in attesa.',
    new: '<b>{{name}}</b> diventa subito titolare di {{restaurant}}.',
    email:
      'Le credenziali vengono inviate a <b>{{email}}</b>. Controlla l’indirizzo: chi lo possiede può accedere come titolare.',
    team: '<b>{{name}}</b> diventa titolare di {{restaurant}}.',
    group_access: 'Come titolare avrà accesso a tutti i ristoranti di {{group}}, forse più di quelli che ha oggi.',
    keep: '<b>{{name}}</b> resta nel team come Operatore.',
    remove: '<b>{{name}}</b> viene rimosso dal team e non può più accedere.',
  },
  error: {
    title: 'Impossibile cambiare il titolare.',
    description: 'Non è stato modificato nulla. Riprova o contatta l’assistenza se il problema persiste.',
  },
  buttons: {
    close: 'Chiudi',
    continue: 'Continua',
    cancel: 'Annulla',
    back: 'Indietro',
    remove_as_owner: 'Rimuovi come titolare',
    make_owner: 'Nomina titolare',
    saving: 'Salvataggio…',
    try_again: 'Riprova',
    choose_instead: 'Scegli invece {{name}}',
    invite_instead: 'Invita invece una persona nuova',
  },
};
